import { WarningAmberOutlined, SyncOutlined, CheckOutlined, CloseOutlined, } from "@mui/icons-material";
import CustomTooltip from "../../../components/CustomTooltip";
import NotificationComponent from "./NotificationComponent/NotificationComponent";


const iconMap = {
    error: ["Request failed with status code 500", "BP_F", "CSP_P_U", "CSP_C_U", "CSP_P_C_U", "CSP_F",
        "CSD_P_U", "CSD_C_U", "CSD_P_C_U", "CSD_F"],
    sync: ["PD_Sync", "PP_Sync"],
    success: ["BP_U", "CSP_U", "CSD_U", "E_CSP_U", "EP_U","DP_U"],
    warning: ["BP_P_U", "BP_E"],
};

const getIconAndStyle = (code) => {
    if (iconMap.error.includes(code)) {
        return { icon: <WarningAmberOutlined />, bg: "bg-red-500" };
    }
    if (iconMap.sync.includes(code)) {
        return { icon: <SyncOutlined />, bg: "bg-cyan-500" };
    }
    if (iconMap.success.includes(code)) {
        return { icon: <CheckOutlined />, bg: "bg-cyan-500" };
    }
    if (code === "BP_E") {
        return { icon: <WarningAmberOutlined sx={{ transform: 'scaleX(-1)' }} />, bg: "bg-yellow-600" };
    }
    return null;
};

export default function NotificationItem({ Notify, timeDifferenceText, showNotificationDescription, handleToDeleteReadFile }) {
    const iconData = getIconAndStyle(Notify.NotificationReasonCode);

    return (
        <div className="text-left p-2 hover:bg-pink-50 hover:cursor-pointer">
            <div className="flex justify-content-center align-items-center gap-2">
                {iconData && (
                    <div className={`${iconData.bg} text-white p-2 border-circle`}>
                        {iconData.icon}
                    </div>
                )}

                <div className="text-xs font-medium flex-1">
                    {Notify.NotificationReasonCode && showNotificationDescription(Notify.NotificationReasonCode)}
                </div>

                <div className="align-self-baseline">
                    <p className="text-xs">
                        <CustomTooltip text="Delete" placement="bottom">
                            <button className="p-1 text-cyan-600" onClick={() => handleToDeleteReadFile(Notify)}>
                                <CloseOutlined fontSize="small" />
                            </button>
                        </CustomTooltip>
                    </p>
                </div>
            </div>

            <div className="flex justify-content-between align-items-center">
                <p className="text-xs text-gray-500">{timeDifferenceText}</p>
                {[
                    "BP_P_U", "CSP_P_U", "CSP_C_U", "CSP_P_C_U",
                    "CSD_P_U", "CSD_C_U", "CSD_P_C_U",
                ].includes(Notify.NotificationReasonCode) && (
                        <NotificationComponent Notify={Notify} />
                    )}
            </div>
        </div>
    );
}
